import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, unref as _unref, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "busy-indicator-container"
}

import isNil from 'lodash/isNil'
import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'

import BusyIndicator from '@/components/common/BusyIndicator.vue'
import NotificationBanner from '@/components/common/NotificationBanner.vue'
import TileSelector from '@/components/common/TileSelector.vue'
import { useLeaguesStore } from '@/store/public/leagues'
import { League } from '@/store/public/leagues.types'
import { getErrorMessage } from '@/utils/error-handling'


export default /*@__PURE__*/_defineComponent({
  __name: 'LeagueSelectionView',
  setup(__props) {

const leagues = useLeaguesStore()
const router = useRouter()

const errorMessage = ref<string | null>(null)
const isLoading = ref<boolean>(false)

function navigateToLeague(league: League): void {
  router.push({ path: `/leagues/${league.season}/${league.id}` })
}

function navigateToSeason(season: string): void {
  router.push({ path: `/leagues/${season}` })
}

onMounted(async () => {
  errorMessage.value = null
  isLoading.value = true

  try {
    await leagues.fetch()
  } catch (e) {
    const message = getErrorMessage(e as Error)
    console.error(`Failed fetching leagues: ${message}`)
    errorMessage.value = message
  }

  isLoading.value = false
})

return (_ctx: any,_cache: any) => {
  return (isLoading.value)
    ? (_openBlock(), _createElementBlock("h1", _hoisted_1, [
        _createVNode(BusyIndicator)
      ]))
    : (errorMessage.value)
      ? (_openBlock(), _createBlock(NotificationBanner, {
          key: 1,
          message: errorMessage.value,
          "is-danger": ""
        }, null, 8, ["message"]))
      : (_unref(isNil)(_unref(leagues).selectedSeason))
        ? (_openBlock(), _createBlock(TileSelector, {
            key: 2,
            items: _unref(leagues).availableSeasons,
            onClick: navigateToSeason
          }, null, 8, ["items"]))
        : (_unref(leagues).availableGroups.length === 0)
          ? (_openBlock(), _createBlock(NotificationBanner, {
              key: 3,
              message: _ctx.$t('leagues.errors.no-leagues'),
              "is-warning": ""
            }, null, 8, ["message"]))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 4 }, _renderList(_unref(leagues).availableGroups, (group, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: `group-${i}`
              }, [
                _createElementVNode("h3", null, _toDisplayString(group.name), 1),
                _createVNode(TileSelector, {
                  items: group.leagues,
                  "label-property": "name",
                  onClick: navigateToLeague
                }, null, 8, ["items"])
              ]))
            }), 128))
}
}

})